import React, { Component } from 'react';
import { withRouter, RouteComponentProps } from 'react-router';
import { IonRow, IonCol, IonSkeletonText } from '@ionic/react';

type Props = RouteComponentProps<{}> & {
  loading: boolean;
}

class PhotosLoading extends Component<Props> {
  render() {
    return (
      <IonRow className={this.props.loading ? '' : 'hidden'}>
        {[0,1,2,3,4,5].map((item: any, index: number) => {
          return (
            <IonCol key={index} size-lg="4" size-md="4" size-sm="4" size-xs="4">
              <IonSkeletonText class="loading" animated style={{ width: '100%', "minHeight": "150px" }}></IonSkeletonText>
            </IonCol>
          )
        })}
      </IonRow>
    );
  }
};

export default withRouter(PhotosLoading);
